import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OldReportsComponent } from './old-reports.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomInputModule } from "../../../../shared/components/custom-input/custom-input.module";
import { MatSortModule } from '@angular/material/sort';



@NgModule({
    declarations: [
        OldReportsComponent
    ],
    exports: [
        OldReportsComponent
    ],
    imports: [
        CommonModule,
        CustomDatePickerModule,
        CustomDropdownModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        MatPaginatorModule,
        CustomInputModule,
        MatSortModule
    ]
})
export class OldReportsModule { }
